var map = {
	"./01.png": 64392,
	"./02.png": 1251,
	"./03.png": 53498,
	"./04.png": 77269,
	"./5-stars.svg": 8294,
	"./AppStore.svg": 97449,
	"./Applicants-illustration.png": 34629,
	"./Availability-illustration.png": 18493,
	"./Category-illustration.png": 17662,
	"./Choice Filling-illustration.png": 46474,
	"./Fee-illustration.png": 43294,
	"./Registration-mcc-illustration.png": 32567,
	"./Report-illustration.png": 43664,
	"./Verification-illustration.png": 21501,
	"./afmc-illustration.png": 45449,
	"./aiims-illustration.png": 93151,
	"./campus-illustration.png": 43119,
	"./careers-primary.png": 37073,
	"./choice-filing-illustration.png": 38013,
	"./clarity-illustration.png": 5670,
	"./cmc-illustration.png": 38567,
	"./community-illustration.png": 48651,
	"./conducted-illustration.png": 50763,
	"./doctor-men.png": 4055,
	"./doctors.png": 24673,
	"./exam-illustration.png": 95525,
	"./exploring-illustration.png": 5570,
	"./faster-chart.svg": 28641,
	"./flow-mobile-zy.png": 15630,
	"./flow-web-zy.png": 34232,
	"./google-play-badge.png": 19163,
	"./growth-graph.svg": 4479,
	"./growth-illustration.png": 96649,
	"./idea-illustration.png": 67733,
	"./information-table-illustration.png": 53877,
	"./infrastructure-illustration.png": 74453,
	"./low-cost-chart.svg": 97678,
	"./mamc-illustration.png": 81232,
	"./map-illustration.png": 77100,
	"./mcc-neet-flow-mob.png": 77789,
	"./mcc-web-zy.png": 45965,
	"./modes-illustration.png": 41914,
	"./money-illustration.png": 76958,
	"./number-illustration.png": 76915,
	"./offered-illustration.png": 23181,
	"./participation-illustration.png": 7139,
	"./placement-illustration.png": 62909,
	"./rankings-illustration.png": 41661,
	"./recognition-illustration.png": 52169,
	"./registration-illustration.png": 78839,
	"./resources-illustration.png": 74439,
	"./seat-illustration.png": 62203,
	"./tailor-illustration.png": 51417,
	"./tailored-illustration.png": 76488,
	"./trends-illustration.png": 82422,
	"./ug-video-thumbnail.webp": 71476,
	"./videos-illustration.png": 48394,
	"./zynerd-allotment-mapping.png": 77929,
	"./zynerd-closing-ranks.png": 89223,
	"./zynerd-dashboard.png": 7660,
	"./zynerd-institutes.png": 76338,
	"./zynerd-seat-matrix.png": 63855,
	"./zynerd-videos.png": 87854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62229;